import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconLockClosed32(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={32}
            height={32}
            className={customClassName}
            name="IconLockClosed32"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M20 9v2h-8V9a4 4 0 0 1 8 0m-10 2V9a6 6 0 0 1 12 0v2h1a4 4 0 0 1 4 4v9a4 4 0 0 1-4 4H9a4 4 0 0 1-4-4v-9a4 4 0 0 1 4-4zm12 2H9a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-9a2 2 0 0 0-2-2zm-5.031 7.75a2 2 0 1 0-1.938 0q-.03.12-.031.25v1a1 1 0 1 0 2 0v-1q0-.13-.031-.25"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconLockClosed32);
